/*
 * Copyright (c) 2014-2023 Comparatio USA  LLC. <https://www.comparatio.com>
 */

export const exportCols = [
  {
    field: 'CO1_NAME',
    header: 'Company',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'CU1_NAME',
    header: 'Customer',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'CU0_NAME',
    header: 'Master Customer',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: false, checked: false },
    width: 125,
  },
  {
    field: 'CONTRACT_BIN_ID',
    header: 'Bin ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 175,
  },
  {
    field: 'ITEM_ID',
    header: 'Item ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 175,
  },
  {
    field: 'CUSTOMER_PART_NO',
    header: 'Cust. Part No.',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'RA1_SHIP_TO_ID',
    header: 'Rack ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'RA1_SHIP_TO_NAME',
    header: 'Rack Name',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'PL1_SHORT_CODE',
    header: 'Plant Short Code',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'PL1_NAME',
    header: 'Plant Name',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_ITEM_DESC',
    header: 'Item Desc.',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_EXTENDED_DESC',
    header: 'Ext Desc.',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_FAMILY',
    header: 'Family',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_CONTRACT_NO',
    header: 'Contract No.',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_REORDER_QTY',
    header: 'Reorder Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_MIN_QTY',
    header: 'Min Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_MAX_QTY',
    header: 'Max Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_CAPACITY',
    header: 'Capacity',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_AVAILABLE_QTY',
    header: 'Available Qty',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: false, checked: false },
    width: 75,
  },
  {
    field: 'MD1_ON_HAND_QTY',
    header: 'On Hand Qty',
    visible: false,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_UM',
    header: 'UM',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_UM_SIZE',
    header: 'Unit Size',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_PRICE',
    header: 'Price',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_LINE',
    header: 'Line',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_LINE_FEED',
    header: 'Line Feed',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_LINE_STATION',
    header: 'Line Station',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_BIN_TYPE',
    header: 'Bin Type',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_BIN_SIZE',
    header: 'Bin Size',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_REP',
    header: 'Rep',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_REGION',
    header: 'Region',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_OWNER_OF_BIN',
    header: 'Owner of Bin',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_OWNER_OF_RACK',
    header: 'Owner of Rack',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_BARCODE',
    header: 'Barcode',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
];

export const newOrderTableCols = [
  {
    field: 'CO1_ID',
    header: 'CO1_ID',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: false, checked: false },
    width: 0,
  },
  {
    field: 'CO1_NAME',
    header: 'Company',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'CU1_NAME',
    header: 'Customer',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'CONTRACT_BIN_ID',
    header: 'Bin ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 175,
  },
  {
    field: 'ITEM_ID',
    header: 'Item ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 175,
  },
  {
    field: 'CUSTOMER_PART_NO',
    header: 'Cust. Part No.',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'RA1_SHIP_TO_ID',
    header: 'Rack ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'RA1_SHIP_TO_NAME',
    header: 'Rack Name',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'PL1_NAME',
    header: 'Plant Name',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_ITEM_DESC',
    header: 'Item Desc.',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 225,
  },

  {
    field: 'MD1_REORDER_QTY',
    header: 'Reorder Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_MIN_QTY',
    header: 'Min Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_MAX_QTY',
    header: 'Max Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_CAPACITY',
    header: 'Capacity',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_ON_HAND_QTY',
    header: 'On Hand Qty',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_UM',
    header: 'UM',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_UM_SIZE',
    header: 'Unit Size',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_PRICE',
    header: 'Price',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_LINE',
    header: 'Line',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_LINE_FEED',
    header: 'Line Feed',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_LINE_STATION',
    header: 'Line Station',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_BIN_TYPE',
    header: 'Bin Type',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },

  {
    field: 'MD1_BARCODE',
    header: 'Barcode',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'CU0_NAME',
    header: 'Master Customer',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: false, checked: false },
    width: 0,
  },
  {
    field: 'PL1_SHORT_CODE',
    header: 'Plant Short Code',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_EXTENDED_DESC',
    header: 'Ext Desc.',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_FAMILY',
    header: 'Family',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_CONTRACT_NO',
    header: 'Contract No.',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_AVAILABLE_QTY',
    header: 'Available Qty',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: false, checked: false },
    width: 75,
  },
  {
    field: 'MD1_BIN_SIZE',
    header: 'Bin Size',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_REP',
    header: 'Rep',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_REGION',
    header: 'Region',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_OWNER_OF_BIN',
    header: 'Owner of Bin',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_OWNER_OF_RACK',
    header: 'Owner of Rack',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
];

export const altExportCols = [
  {
    field: 'CO1_NAME',
    header: 'Company',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'CU1_NAME',
    header: 'Customer',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'CU0_NAME',
    header: 'Master Customer',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: false, checked: false },
    width: 125,
  },
  {
    field: 'CONTRACT_BIN_ID',
    header: 'Bin ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 175,
  },
  {
    field: 'ITEM_ID',
    header: 'Item ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 175,
  },
  {
    field: 'CUSTOMER_PART_NO',
    header: 'Cust. Part No.',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'RA1_SHIP_TO_ID',
    header: 'Rack ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'RA1_SHIP_TO_NAME',
    header: 'Rack Name',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'PL1_SHORT_CODE',
    header: 'Plant Short Code',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'PL1_NAME',
    header: 'Plant Name',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_ITEM_DESC',
    header: 'Item Desc.',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_EXTENDED_DESC',
    header: 'Ext Desc.',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_FAMILY',
    header: 'Family',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_CONTRACT_NO',
    header: 'Contract No.',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_REORDER_QTY',
    header: 'Reorder Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_MIN_QTY',
    header: 'Min Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_MAX_QTY',
    header: 'Max Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_CAPACITY',
    header: 'Capacity',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_AVAILABLE_QTY',
    header: 'Available Qty',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: false, checked: false },
    width: 75,
  },
  {
    field: 'MD1_ON_HAND_QTY',
    header: 'On Hand Qty',
    visible: false,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_UM',
    header: 'UM',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_UM_SIZE',
    header: 'Unit Size',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
 /* {
    field: "MD1_PRICE",
    header: "Price",
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },*/
  {
    field: 'MD1_LINE',
    header: 'Line',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_LINE_FEED',
    header: 'Line Feed',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_LINE_STATION',
    header: 'Line Station',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_BIN_TYPE',
    header: 'Bin Type',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_BIN_SIZE',
    header: 'Bin Size',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_REP',
    header: 'Rep',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_REGION',
    header: 'Region',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_OWNER_OF_BIN',
    header: 'Owner of Bin',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_OWNER_OF_RACK',
    header: 'Owner of Rack',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_BARCODE',
    header: 'Barcode',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
];

export const altNewOrderTableCols = [
  {
    field: 'CO1_NAME',
    header: 'Company',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'CU1_NAME',
    header: 'Customer',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'CONTRACT_BIN_ID',
    header: 'Bin ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 175,
  },
  {
    field: 'ITEM_ID',
    header: 'Item ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 175,
  },
  {
    field: 'CUSTOMER_PART_NO',
    header: 'Cust. Part No.',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'RA1_SHIP_TO_ID',
    header: 'Rack ID',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'RA1_SHIP_TO_NAME',
    header: 'Rack Name',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'PL1_NAME',
    header: 'Plant Name',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_ITEM_DESC',
    header: 'Item Desc.',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_REORDER_QTY',
    header: 'Reorder Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_MIN_QTY',
    header: 'Min Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_MAX_QTY',
    header: 'Max Qty',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_CAPACITY',
    header: 'Capacity',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_ON_HAND_QTY',
    header: 'On Hand Qty',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_UM',
    header: 'UM',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_UM_SIZE',
    header: 'Unit Size',
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
/*  {
    field: "MD1_PRICE",
    header: "Price",
    visible: true,
    filter: false,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },*/
  {
    field: 'MD1_LINE',
    header: 'Line',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_LINE_FEED',
    header: 'Line Feed',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_LINE_STATION',
    header: 'Line Station',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 75,
  },
  {
    field: 'MD1_BIN_TYPE',
    header: 'Bin Type',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 100,
  },

  {
    field: 'MD1_BARCODE',
    header: 'Barcode',
    visible: true,
    filter: true,
    sort: true,
    export: { visible: true, checked: true },
    width: 125,
  },
  {
    field: 'CU0_NAME',
    header: 'Master Customer',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: false, checked: false },
    width: 0,
  },
  {
    field: 'PL1_SHORT_CODE',
    header: 'Plant Short Code',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_EXTENDED_DESC',
    header: 'Ext Desc.',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_FAMILY',
    header: 'Family',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_CONTRACT_NO',
    header: 'Contract No.',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 225,
  },
  {
    field: 'MD1_AVAILABLE_QTY',
    header: 'Available Qty',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: false, checked: false },
    width: 75,
  },
  {
    field: 'MD1_BIN_SIZE',
    header: 'Bin Size',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_REP',
    header: 'Rep',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_REGION',
    header: 'Region',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_OWNER_OF_BIN',
    header: 'Owner of Bin',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
  {
    field: 'MD1_OWNER_OF_RACK',
    header: 'Owner of Rack',
    visible: false,
    filter: false,
    sort: false,
    export: { visible: true, checked: true },
    width: 100,
  },
];




// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/master-data/master-data.cols.ts